import request from "@/utils/request";

//查看公告
export function search_announce(data) {
    return request({
        url: "/search_announce",
        method: "post",
        data: data,
    });
}

//增加公告
export function add_announce(data) {
    return request({
        url: "/add_announce",
        method: "post",
        data: data,
    });
}


//修改公告
export function update_announce(data) {
    return request({
        url: "/update_announce",
        method: "post",
        data: data,
    });
}

//删除公告
export function delete_announce(data) {
    return request({
        url: "/delete_announce",
        method: "post",
        data: data,
    });
}
